var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBackArrow = function SvgIconBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121414",
    d: "M17.424 7.167h-14.4a.97.97 0 0 1-.977-.976.97.97 0 0 1 .976-.975h14.401a.97.97 0 0 1 .976.975.97.97 0 0 1-.976.976"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121414",
    d: "M1.378 7.14a.95.95 0 0 1-.71-.307.973.973 0 0 1 .041-1.38L5.993.462a.985.985 0 0 1 1.38.042.973.973 0 0 1-.042 1.38l-5.284 4.99a.97.97 0 0 1-.669.265"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#121414",
    d: "M6.662 12.186a.95.95 0 0 1-.67-.265L.71 6.861a.97.97 0 0 1-.028-1.38.97.97 0 0 1 1.38-.028l5.284 5.06c.39.377.404.99.028 1.38a1 1 0 0 1-.711.307z"
  })));
};
export default SvgIconBackArrow;